import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "main",
    {
      staticClass: "d-flex flex-column",
      class: _setup.isMobile ? "px-2 py-6 ga-6" : "ga-4",
      attrs: { "data-qa": "ethical_commission_content" },
    },
    [
      _c(
        _setup.InfoCard,
        {
          attrs: {
            "data-qa": "ethical_commission_content_goals_and_objectives",
            title: _setup.t("Цели и задачи", _setup.options),
          },
        },
        [
          _c("div", { staticClass: "text-body-2" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.t(
                    "Этический комитет — независимая комиссия для оценки отзывов и разрешения спорных ситуаций между медицинскими специалистами и пациентами. Способствует публикации достоверных и обоснованных отзывов на портале. Контролирует соблюдение прав медработников и пациентов при публичном выражении мнения.",
                    _setup.options
                  )
                ) +
                "\n      "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        _setup.InfoCard,
        {
          attrs: {
            "data-qa": "ethical_commission_content_meetings_results",
            title: _setup.t("Результаты заседаний", _setup.options),
          },
        },
        [
          _c("div", { staticClass: "text-body-2 text--text" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.t(
                    "Два раза в месяц члены этического комитета рассматривают обращения на заочном и очном заседаниях. За месяц принимается решение по 8 - 10 заявкам.",
                    _setup.options
                  )
                ) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex gc-5 gr-4",
              class: _setup.isMobile ? "flex-column" : "justify-space-between",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "bg-secondary rounded py-3 px-5 d-flex align-center w-100",
                },
                [
                  _c("div", {
                    staticClass: "ui-icon-shield icon-secondary--text",
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-body-1 text--text ml-4" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.ethicalCommissionMeetingsCount) +
                        " " +
                        _vm._s(_setup.getMeetingsCountCaseText()) +
                        " " +
                        _vm._s(_setup.t("было проведено", _setup.options)) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "bg-secondary rounded py-3 px-5 d-flex align-center w-100",
                },
                [
                  _c("div", {
                    staticClass: "ui-icon-hand-shaking icon-secondary--text",
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-body-1 text--text ml-4" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _setup.t("Дали независимую оценку", _setup.options)
                        ) +
                        " " +
                        _vm._s(_vm.ethicalCommissionCasesCount) +
                        " " +
                        _vm._s(_setup.getCasesCountCaseText()) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            VBtn,
            {
              class: { "align-self-start": !_setup.isMobile },
              attrs: {
                href: _setup.reverseFull({
                  name: "info_ethical_commission_meetings",
                }),
                color: "primary",
                depressed: "",
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.t("Перейти к результатам", _setup.options)) +
                  "\n      "
              ),
              _c("span", {
                staticClass: "ui-icon-arrow-next bg-gray-0--text ml-2",
              }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _setup.context.feature_flags.update_ethical_commission_page
        ? _c(
            _setup.InfoCard,
            {
              attrs: {
                "data-qa": "ethical_commission_content_structure",
                title: _setup.t(
                  "Структура этического комитета",
                  _setup.options
                ),
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column ga-4 text-body-2 text--text",
                },
                [
                  _c("div", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _setup.t(
                            "Структура Этического комитета включает Этическую коллегию и Этический консилиум.",
                            _setup.options
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _setup.t(
                              "Этическая коллегия состоит из",
                              _setup.options
                            )
                          ) +
                          "\n        "
                      ),
                      _setup.gradeCount.reviewers > 0
                        ? [
                            _vm._v(
                              "\n          " +
                                _vm._s(_setup.gradeCount.reviewers) +
                                "\n        "
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.getReviewersLabel()) +
                          ", " +
                          _vm._s(
                            _setup.t(
                              "оперативно принимающих решения и формирующих первичное заключение. Участвуют только в заочных заседаниях. На данном уровне принимается решение по подавляющему большинству обращений. Заседания проводятся раз в месяц.",
                              _setup.options
                            )
                          ) +
                          "\n        "
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _setup.t(
                              "Этический консилиум включает",
                              _setup.options
                            )
                          ) +
                          "\n        "
                      ),
                      _setup.gradeCount.experts > 0
                        ? [
                            _vm._v(
                              "\n          " +
                                _vm._s(_setup.gradeCount.experts) +
                                "\n        "
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(
                        " " +
                          _vm._s(_setup.getExpertsLabel()) +
                          ". " +
                          _vm._s(
                            _setup.t(
                              "Собирается только по сложным, прецедентным или конфликтным случаям, требующим глубокой аргументации. Также участвуют в работе «Этической коллегии». Очные заседания проводятся по необходимости. В случае привлечения экспертов, указывается, что «Решение принято коллегией советников Этического консилиума по итогам очной полемической дискуссии и устных обоснований экспертов».",
                              _setup.options
                            )
                          ) +
                          "\n        "
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        _setup.InfoCard,
        {
          attrs: {
            "data-qa": "ethical_commission_content_initiate_check",
            title: _setup.t("Как инициировать проверку", _setup.options),
          },
        },
        [
          _c("div", { staticClass: "text-body-2 text--text" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.t(
                    "Запросить проверку принятого порталом решения о публикации или непубликации отзыва может пациент, врач или клиника.",
                    _setup.options
                  )
                )
            ),
            _c("br"),
            _vm._v(" "),
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.t("Обращения можно направлять на", _setup.options)
                ) +
                " "
            ),
            _c(
              "a",
              {
                staticClass: "primary--text link-decoration-none",
                attrs: { href: "mailto:ethics@medrocket.ru" },
              },
              [_vm._v("ethics@medrocket.ru")]
            ),
            _vm._v(
              " " +
                _vm._s(
                  _setup.t(
                    "с указанием ссылки на спорный отзыв.",
                    _setup.options
                  )
                ) +
                " "
            ),
            _c("br"),
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.t(
                    "До отправки обращения по спорному отзыву убедитесь:",
                    _setup.options
                  )
                ) +
                " "
            ),
            _c("br"),
            _vm._v(" "),
            _vm._v(
              "\n      • " +
                _vm._s(
                  _setup.t(
                    "что отзыв прошёл расширенную проверку или собран колл-центром",
                    _setup.options
                  )
                ) +
                " "
            ),
            _c("br"),
            _vm._v(
              "\n      • " +
                _vm._s(
                  _setup.t(
                    "в письме указана ссылка на отзыв и дата публикации",
                    _setup.options
                  )
                ) +
                " "
            ),
            _c("br"),
            _vm._v(
              "\n      • " +
                _vm._s(
                  _setup.t(
                    "вы написали своими словами, почему решение о публикации / непубликации отзыва является неэтичным (не соответствующим нормам этики и морали).",
                    _setup.options
                  )
                ) +
                "\n      "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        _setup.InfoCard,
        {
          attrs: {
            "data-qa": "ethical_commission_content_members",
            title: _setup.t("Члены этического комитета", _setup.options),
          },
        },
        [
          _vm._l(_vm.ethicalCommissions, function (ethicalCommission, index) {
            return [
              _c(
                "div",
                {
                  key: `member-group-${index}`,
                  staticClass: "member-group__title text-subtitle-1",
                  attrs: {
                    "data-qa": "ethical_commission_content_member_group",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(ethicalCommission.member_group_name) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._l(ethicalCommission.members, function (member, indexMember) {
                return _c(_setup.MemberCard, {
                  key: `member-${member.last_name}-${member.first_name}-${member.second_name}-${indexMember}`,
                  attrs: { member: member },
                })
              }),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }